/* RK Filterleiste — Komfort über dem Formular.
   Ohne dieses Skript bleibt alles bedienbar: Das Feld ist dann sichtbar und
   „Filter anwenden" schickt das Formular ab. */
(function () {
  'use strict';

  function start(leiste) {
    var form = leiste.querySelector('[data-rk-filter-form]');
    var feld = leiste.querySelector('[data-rk-filter-feld]');
    var schalter = leiste.querySelector('[data-rk-filter-schalter]');
    var sort = leiste.querySelector('[data-rk-sort]');

    // Sortierung sofort anwenden.
    if (sort && form) {
      sort.addEventListener('change', function () { form.submit(); });
    }

    if (!feld || !schalter) return;

    // Das Feld ist im HTML offen (hidden wird erst hier gesetzt), damit es
    // ohne JavaScript nutzbar bleibt.
    var offen = false;

    function zeigen(an) {
      offen = an;
      feld.hidden = !an;
      schalter.setAttribute('aria-expanded', String(an));
    }

    zeigen(false);

    schalter.addEventListener('click', function () { zeigen(!offen); });

    // Mit Escape schließen, wenn der Fokus im Feld sitzt.
    leiste.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offen) {
        zeigen(false);
        schalter.focus();
      }
    });

    // Wer gefiltert hat, soll die aktive Auswahl sehen.
    if (leiste.querySelector('.rk-filter__aktiv')) zeigen(false);
  }

  function alle() {
    document.querySelectorAll('[data-rk-filter]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', alle);
})();
